<template>
  <div class="pages">
    <Header />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/header'
import Footer from '@/components/footer'

export default {
  name: 'pages',
  components: { Header, Footer },
  data() {
    return {}
  },
  mounted() {},
  methods: {},
}
</script>
